import React, { useEffect, useState } from 'react'
import PageTitle from '../../../jsx/layouts/PageTitle';
import ReactPaginate from 'react-paginate';
import { getBatchAthletes } from '../../../services/adminApiService/batchManagementApi/BatchManagementApiService';
import FilterNumber from '../../../jsx/components/FilterNumberDropDown/FilterNumber';
import SearchFilter from '../../../jsx/components/SearchFilter/SearchFilter';
import useSearchValue from '../../../hooks/useSearchValue';
import { useSport } from '../../../context/SportContext';
import SportFilter from '../sportFilter/SportFilter';
import TextMasked from '../../../utils/TextMasked';

const AthletesList = () => {
    const [athletes, setAthletes] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const { searchValue, setSearchValue, debouncedSearchValue } = useSearchValue();
    const { selectedSportId } = useSport();

    useEffect(() => {
        const fetchAthletes = async () => {
            setLoading(true);
            try {
                const response = await getBatchAthletes({
                    sport_id: selectedSportId || undefined,
                    search: debouncedSearchValue || undefined,
                    per_page: perPage,
                    page: currentPage,
                });
                setAthletes(response?.data?.data || []);
                setTotalPages(response?.data?.pagination?.last_page || 1);
            } catch (error) {
                console.error('Athletes list error:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchAthletes();
    }, [selectedSportId, debouncedSearchValue, perPage, currentPage]);

    return (
        <>
            <PageTitle activeMenu="All Athletes" motherMenu="Dashboard" />
            <div className="col-12">
                <div className="card filter-card-wrapper">
                    <div className="px-3 d-flex justify-content-between">
                        <div className="d-flex mt-3 mx-2">
                            <div>
                                <FilterNumber value={perPage} onChange={(val) => {
                                    setPerPage(val);
                                    setCurrentPage(1);
                                }} />
                            </div>
                            <div>
                                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                            </div>
                        </div>
                    </div>
                    <div className="mx-4 d-flex mt-2">
                        <div>
                            <SportFilter setCurrentPage={setCurrentPage} />
                        </div>
                    </div>

                    <div className="card-body">
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="w-100 table-responsive">
                                <table id="example" className="display w-100 dataTable">
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            <th>Unique Id</th>
                                            <th>Name</th>
                                            <th>Sport Name</th>
                                            <th>Category</th>
                                            <th>Contact Number</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {athletes.length > 0 ? (
                                            athletes.map((data, index) => {
                                                const serialNumber = (currentPage - 1) * perPage + (index + 1);
                                                const fullName = [data?.first_name, data?.middle_name, data?.last_name].filter(Boolean).join(' ');
                                                return (
                                                    <tr key={data.id}>
                                                        <td>{serialNumber}</td>
                                                        <td>{data?.atom_id}</td>
                                                        <td>{fullName}</td>
                                                        <td>{data?.sport_name}</td>
                                                        <td>{data?.user_type_name}</td>
                                                        <td><TextMasked value={data?.mobile} type="phone" /></td>
                                                    </tr>
                                                );
                                            })
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">Data is not available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </div>
                <ReactPaginate
                    nextLabel="next >"
                    onPageChange={(e) => setCurrentPage(e.selected + 1)}
                    pageRangeDisplayed={8}
                    marginPagesDisplayed={7}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination d-flex flex-wrap"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                    forcePage={currentPage - 1}
                />
            </div>
        </>
    )
}

export default AthletesList
